export interface OptionValue {
    value: number;
    label: string;
}

const timeOptions: OptionValue[] = [];
for (let i = 0; i < 24 * 60; i += 15) {
    const minute = `0${i % 60}`.slice(-2);
    if (i === 0) {
        timeOptions.push({
            value: i,
            label: `12:00am`,
        });
    } else if (i >= 720 && i < 780) {
        timeOptions.push({
            value: i,
            label: `12:${minute}pm`,
        });
    } else {
        const hour = `${i / 60 === 12 ? 12 : Math.floor((i / 60) % 12)}`.slice(-2);
        let ampm = '';
        if (i / 60 === 12 || Math.floor(i / 60) < 12) {
            ampm = 'am';
        } else {
            ampm = 'pm';
        }
        if (i === 720) {
            ampm = 'pm';
        }
        timeOptions.push({
            value: i,
            label: `${hour}:${minute}${ampm}`,
        });
    }
}

export default timeOptions;
